import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getAllCategory as getSuperCategoryList,
  getAllVendors
} from '../../../store/actions/user/User';
import {
  getAllSuperCategory,
  sendMail,
  pushEvent,
  getOfferMessage
} from '../../../store/actions/user/User';
import Typography from '@material-ui/core/Typography';
import { saveEventData } from "../../../utils/events-handler"
import Footer from '../Footer/Footer';
import PlacesWithStandaloneSearchBox from './map';
import CircularProgress from '@material-ui/core/CircularProgress';
import Snackbar from '@material-ui/core/Snackbar';
import Alert from '@material-ui/lab/Alert';
import Tour from 'reactour'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import { Hidden } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Marquee from "react-fast-marquee";
import Grid from '@material-ui/core/Grid';


const steps = [
  {
    selector: '.mainLocation',
    content: 'Welcome to Grospick. Choose the Location first.',
  },
  {
    selector: '.categ',
    content: 'Now Choose the Category of your choice and start exploring',

  }
]
class Home extends Component {
  state = {
    load: false,
    name: '',
    email: '',
    address: '',
    phone: '',
    openLocation: false,
    openTour: false,
    openLocationPopup: false,
    eventsApiCall: null,
  };

  constructor(props) {
    super(props);
    this.runLoader = this.runLoader.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.locationRef = React.createRef();
  }

  componentDidMount() {
    this.props.getSuperCategoryList();
    this.props.getAllSuperCategory();
    this.props.getOfferMessage()
    setTimeout(() => {
      this.setState({ isLoading: false });
    }, 3000);

    setTimeout(() => {
      this.changeText();
    }, 50);

    const tourShown = localStorage.getItem('tourShown')
    if (!tourShown) {
      this.setState({
        openTour: true
      })
      localStorage.setItem('tourShown', true)
    }
    const street = localStorage.getItem('street');
    const lat = localStorage.getItem('latitude');
    const lng = localStorage.getItem('longitude');
    if (!(street && lat && lng)) {
      this.setState({
        openLocationPopup: true
      })
    }
    saveEventData(this.props.pushEvent, "HomePageView")
    const eventsApiCall = setInterval(() => {
      saveEventData(this.props.pushEvent, "HomePageView")
    }, 120000)
    this.setState({
      eventsApiCall: eventsApiCall
    })

  }

  componentWillUnmount() {
    const eventsApiCall = this.state.eventsApiCall
    if (eventsApiCall) {
      clearInterval(eventsApiCall)
    }
  }



  disableBody = target => disableBodyScroll(target)
  enableBody = target => enableBodyScroll(target)

  getVendors(superCategoryId, superCategory) {
    if (
      superCategory === 'Restaurant' ||
      superCategory === 'restaurant' ||
      superCategory === '8fe90210-2198-11eb-9bd5-25749c91958e' ||
      superCategory === '8fe90210-2198-11eb-9bd5-25749c91958e'
    ) {
      this.props.history.push('/vendors2/' + superCategory);
    } else {
      this.props.history.push({
        pathname: '/vendors/super/' + superCategoryId,
        state: { category: superCategory }
      });
    }
  }

  getli() {
    this.props.history.push('/liquor');
  }

  runLoader() {
    this.setState({ load: true });
    setTimeout(() => {
      this.setState({ load: false });
    }, 2000);
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }
  handleSubmit() {
    this.props.sendMail(this.state);
    document.getElementById('form1').reset();
    document.getElementById('form2').reset();
  }
  changeText() {
    var x = document.getElementById('mySpan');
    if (x) {
      const myArr = [
        'Strathfield',
        'Homebush',
        'Burwood',
        'Enfield',
        'Concord',
      ];
      var i = 0;
      setInterval(change, 2000);
      function change() {
        x.innerHTML = myArr[i] + ".";
        i++;
        if (i >= myArr.length) {
          i = 0;
        }
      }
    }
  }

  redirectTo = (item) => {
    const street = localStorage.getItem('street');
    const lat = localStorage.getItem('latitude');
    const lng = localStorage.getItem('longitude');
    if (street && lat && lng) {
      if (item?.isPicknDrop) {
        this.props.history.push({
          pathname: `/pick-and-drop`,
        });
      }
      else if (item?.isFlights) {
        this.props.history.push({
          pathname: `/flights`,
        });
      }
      else if (item?.name === 'Liquor Outlets') {
        this.props.history.push({
          pathname: `/liquor-vendor/${item?.id}`,
          state: {
            isRestaurant: item?.isResturant
          }
        });
      } else {
        this.props.history.push({
          pathname: `/super-category/${item?.id}`,
          state: {
            isRestaurant: item?.isResturant
          }
        });
      }
    } else {
      if (this.locationRef) {
        this.setState({ openLocation: true });
        setTimeout(() => {
          this.setState({ openLocation: false });
        }, 20000);
        this.locationRef.current.refs.input.focus();
      }
    }
  };

  handleClose() {
    this.setState({
      openLocationPopup: false
    })
  }



  closeTour() {
    this.setState({
      openTour: false
    })
    localStorage.setItem('tourShown', true)
  }

  render() {
    return (
      <div style={{ marginTop: '3.6em', backgroundColor: '#f6f9fc' }}>
        <Hidden xsDown>
          <Tour
            accentColor="rgb(1, 160, 90)"
            steps={steps}
            rounded={10}
            onAfterOpen={this.disableBody}
            onBeforeClose={this.enableBody}
            isOpen={this.state.openTour}
            onRequestClose={this.closeTour.bind(this)} />
        </Hidden>
        <Snackbar
          open={this.props.email_message}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          autoHideDuration={3000}
        >
          <Alert severity="success">Your response has been recorded.</Alert>
        </Snackbar>
        <Snackbar
          open={this.state.openLocation}
          anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
          autoHideDuration={1000}
        >
          <Alert severity="warning">please select location</Alert>
        </Snackbar>
        <Hidden smUp>
          <Dialog
            open={this.state.openLocationPopup}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"Please select your Location"}</DialogTitle>
            <DialogContent>
            </DialogContent>
            <DialogActions>
              <PlacesWithStandaloneSearchBox
                handleClose={this.handleClose.bind(this)}
                location={this.locationRef}
              ></PlacesWithStandaloneSearchBox>
            </DialogActions>
          </Dialog>
        </Hidden>
        {this.props.offer_messages && this.props.offer_messages.length > 0 && this.props.offer_messages[0].message.trim().length > 0 &&
          <div className="offers">
            <section>
              <div className="container">
                <Typography variant="span" gutterBottom>
                  <Marquee gradient={false} delay={2} speed={30}>
                    {this.props.offer_messages[0].message}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  </Marquee>
                </Typography>
              </div>
            </section>
          </div>
        }
        <Hidden xsDown>
          <div className="bgImage2">
            <div className="container">
              <div className="row" style={{ textAlign: 'initial' }}>
                <div className="row" style={{ padding: 0, margin: 0 }}>
                  <div className="col-12 mt-5 ">
                    <h1 style={{ color: '#131929' }}>
                      {' '}
                      <b
                        className="header-font"
                        style={{
                          textShadow: '#ffffff99 1px 0 1px',
                          fontWeight: '800'
                        }}
                      >
                        {' '}
                        Delivering in&nbsp;<span id="mySpan"></span>&nbsp;
                      </b>
                    </h1>
                  </div>
                  <div className="col-12">
                    <b
                      style={{
                        // color: '#131929',
                        fontWeight: '700'
                        // textShadow: '#aaaaaa99 1px 0 1px'
                      }}
                    >
                      Food, Drinks, Groceries and more available for delivery.
                    </b>
                  </div>

                  <br />
                  <br />
                  <div style={{ width: '100%' }}>
                    {this.state.openLocation && (
                      <div className="locationError">
                        Please select the location
                      </div>
                    )}

                    <div style={{ display: 'flex' }}>
                      <div
                        className="col-8 col-sm-4 mainLocation"
                        style={{ paddingRight: '0' }}
                      >
                        <PlacesWithStandaloneSearchBox
                          location={this.locationRef}
                        ></PlacesWithStandaloneSearchBox>
                      </div>

                      <div
                        className="col-3 col-sm-2"
                        style={{ paddingLeft: '0' }}
                      >
                        {!this.state.load ? (
                          <button
                            className="btn btn-lg pt-1 pb-1"
                            id="bgBtn"
                            type="submit"
                            style={{
                              color: '#01A05A',
                              background: 'transparent'
                            }}
                            onClick={this.runLoader}
                          >
                            {' '}
                            <i
                              className="fa fa-map-marker"
                              style={{ fontSize: '2em' }}
                            ></i>{' '}
                          </button>
                        ) : (
                          <CircularProgress
                            style={{ marginLeft: '10px', color: 'white' }}
                          />
                        )}
                        <br />
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </Hidden>

        <Hidden smUp>
          <div style={{
            marginBottom: '20px',
            background: 'url(../img/mobile_banner.jpeg)',
            backgroundSize: 'cover',
            padding: '22px 5px 85px',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center center',
          }}>

          </div>
        </Hidden>

        <Hidden smDown>
          <br />
          <br />
        </Hidden>
        <section>
          <div className="container">

            {/* <div className="container"> */}
            {/* <div className="row" style={{ textAlign: 'initial' }}>
              <div className="col-12">
                <h2 style={{ textAlign: 'initial' }}>
                  <b>Pick what you need</b>
                </h2>
              </div>
              <div className="col-12">
                <i
                  className="fa fa-window-minimize"
                  id="line"
                  aria-hidden="true"
                ></i>
                <i className="fa fa-window-minimize" aria-hidden="true"></i>
              </div>
            </div>

            <br /> */}
            <Grid container spacing={3}>

              {this.props.superCategories.length !== 0 ?
                (this.props.superCategories.map((item, i) => (

                  <Grid item xs={6} sm={6} md={4} onClick={() => this.redirectTo(item)} key={item.id} style={{ padding: '6px',cursor:'pointer' }}>
                    <div

                    // style={{ backgroundImage: `url(${item.icon})` }}
                    // onClick={() => this.getVendors(item.id, item.name)}
                    >
                      <img src={item.icon} width="100%" alt="categ" />
                    </div>
                  </Grid>
                ))
                )
                : (
                  <div style={{ height: '100px' }}>
                    <div className="loader-new">
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                      <span></span>
                    </div>
                  </div>
                )}
            </Grid>
            {/* </div> */}
          </div>
        </section>
        <br />
        <br />
        <Hidden smDown>
          <div className="row row-content" style={{ margin: 'auto' }}>
            <div
              className="myBanner"
              id="HomeBanner"
              style={{ backgroundPosition: '100%', background: '#FFFFFF' }}
            >
              <div className="container">
                <div className="row">
                  <div className="col-12 col-xs-12 col-sm-12 col-md-6">
                    <h2
                      className="fo"
                      style={{
                        fontWeight: '700',
                        textAlign: 'initial',
                        marginBottom: 0,
                        paddingBottom: 0,
                        color: '#091B3A'
                      }}
                    >
                      Get anything from
                    </h2>
                    <h1
                      className="fo mb-4"
                      style={{
                        fontWeight: '700',
                        textAlign: 'initial',
                        marginTop: 0,
                        paddingTop: '4px',
                        color: '#01A05A'
                      }}
                    >
                      anywhere
                      <b style={{ color: '#091B3A', fontWeight: '700' }}>,</b> at
                      anytime
                    </h1>
                    <div
                      style={{
                        textAlign: 'left',
                        color: '#393838',
                        fontSize: '17px'
                      }}
                    >
                      <b>
                        Life is too short to waste it in finding the product you
                        need from thousands of products in your Favorite
                        supermarket, just click the photo of the product you need
                        and get it to deliver with Grospick.
                      </b>
                    </div>
                    <br />
                    <div
                      style={{
                        textAlign: 'left',
                        color: '#393838',
                        fontSize: '17px'
                      }}
                    >
                      <b>
                        Our trained shoppers will shop for you in the grocery
                        store and deliver to your home at the exact same price as
                        the stores. Want to eat at your favorite restaurant, but
                        they don't deliver? We will pick up your food and deliver
                        it in minutes. This is a new way of life. The very best in
                        your city, delivered in minutes.
                      </b>
                    </div>

                    <div className="col-12">
                      <div className="row mt-5">
                        <br />
                        <div className="col-md-6 col-xs-12 mb-3">
                          <div className="whyUs">
                            <div className="row">
                              <div
                                className="col-12"
                                style={{ textAlign: 'left', paddingLeft: 0 }}
                              >
                                <h4 style={{ color: '#091B3A', fontWeight: 700 }}>
                                  Available 24x7
                                </h4>
                                <h6
                                  style={{
                                    textTransform: 'none',
                                    color: '#393838',
                                    fontSize: '17px'
                                    // fontWeight: 400
                                  }}
                                >
                                  <b>Order anytime, get it delivered.</b>
                                </h6>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-xs-12 mb-3">
                          <div className="whyUs">
                            <div className="row">
                              <div
                                className="col-12"
                                style={{ textAlign: 'left', paddingLeft: 0 }}
                              >
                                <h4 style={{ color: '#091B3A', fontWeight: 700 }}>
                                  No minimum order
                                </h4>
                                <h6
                                  style={{
                                    textTransform: 'none',
                                    color: '#393838',
                                    fontSize: '17px'
                                    // fontWeight: 400
                                  }}
                                >
                                  <b>
                                    Get deliveries with no minimum order value
                                  </b>
                                </h6>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-xs-12 mb-3">
                          <div className="whyUs">
                            <div className="row">
                              <div
                                className="col-12"
                                style={{ textAlign: 'initial', paddingLeft: 0 }}
                              >
                                <h4 style={{ color: '#091B3A', fontWeight: 700 }}>
                                  Express delivery
                                </h4>
                                <h6
                                  style={{
                                    textTransform: 'none',
                                    color: '#393838',
                                    fontSize: '17px'
                                    // fontWeight: 400
                                  }}
                                >
                                  <b>Quickest way to get things done</b>
                                </h6>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-xs-12 mb-3">
                          <div className="whyUs">
                            <div className="row">
                              <div
                                className="col-12"
                                style={{ textAlign: 'initial', paddingLeft: 0 }}
                              >
                                <h4 style={{ color: '#091B3A', fontWeight: 700 }}>
                                  Quality 100%
                                </h4>
                                <h6
                                  style={{
                                    textTransform: 'none',
                                    color: '#393838',
                                    fontSize: '17px'
                                    // fontWeight: 400
                                  }}
                                >
                                  <b>
                                    Get assured quality products delivered safely
                                    to your place
                                  </b>
                                </h6>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-xs-12 col-sm-12 col-md-6">
                    <div>
                      <img
                        src="./img/good-grospick.jpg"
                        style={{ width: '95%', height: '10%' }}
                        alt=""
                      />
                    </div>
                    <div style={{ display: 'flex' }}>
                      <div
                        className="col-md-6 col-xs-12"
                        style={{ textAlign: 'initial' }}
                      >
                        <img
                          src="./img/google_playt.png"
                          style={{ width: '200px' }}
                          alt=""
                        />
                      </div>
                      <div
                        className="col-md-6 col-xs-12"
                        style={{ textAlign: 'initial' }}
                      >
                        <img
                          src="./img/app_storet.png"
                          style={{ width: '200px' }}
                          alt=""
                        />
                        {/* Modal */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Hidden>

        <div
          className="modal fade"
          id="exampleModalLong"
          tabindex="-1"
          role="dialog"
          aria-labelledby="exampleModalLongTitle"
          aria-hidden="true"
        >
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLongTitle">
                  Become a vendor
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <form id="form2">
                  <div className="form-group">
                    <label for="name">Full Name</label>
                    <input
                      type="text"
                      name="name"
                      onChange={this.handleChange}
                      className="form-control"
                      id="name"
                      placeholder="Full Name"
                    />
                  </div>
                  <div className="form-group">
                    <label for="exampleInputEmail1">Email address</label>
                    <input
                      type="email"
                      onChange={this.handleChange}
                      name="email"
                      className="form-control"
                      id="exampleInputEmail1"
                      aria-describedby="emailHelp"
                      placeholder="Enter email"
                    />
                    <small id="emailHelp" className="form-text text-muted">
                      We'll never share your email with anyone else.
                    </small>
                  </div>
                  <div className="form-group">
                    <label for="exampleInputPassword1">Your Phone number</label>
                    <input
                      type="tel"
                      name="phone"
                      onChange={this.handleChange}
                      className="form-control"
                      id="exampleInputPassword1"
                      placeholder="Your Phone number"
                    />
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-dismiss="modal"
                >
                  Close
                </button>
                <button
                  type="button"
                  style={{ width: '150px' }}
                  onClick={this.handleSubmit}
                  className="btn btn-primary"
                >
                  {!this.props.email_loader ? (
                    'Become a vendor'
                  ) : (
                    <CircularProgress size={21} style={{ color: 'white' }} />
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
const mapStateWithProps = (state) => ({
  categories: state.user.categories,
  superCategories: state.user.superCategories,
  email_loader: state.user.email_loader,
  email_message: state.user.email_message,
  offer_messages: state.user.offer_messages
});

const mapDispatchToProps = (dispatch) => ({
  getSuperCategoryList: () => dispatch(getSuperCategoryList()),
  getAllSuperCategory: () => dispatch(getAllSuperCategory()),
  getAllVendors: (city, latitude, longitude, category) =>
    dispatch(getAllVendors(city, latitude, longitude, category)),
  sendMail: (details) => dispatch(sendMail(details)),
  pushEvent: (details) => dispatch(pushEvent(details)),
  getOfferMessage: () => dispatch(getOfferMessage()),
});

export default connect(mapStateWithProps, mapDispatchToProps)(Home);
